/** @format */

import React from 'react';
import intl from 'react-intl-universal';
//import PercentageCircle from 'src/ui/library/PercentageCircle';
import QuestionnaireTopHeader from './QuestionnaireTopHeader';
import { QUESTIONNAIRE_PAGE_URL, CASE_DETAIL_URL } from 'src/constants/constants.js';
import urlParamsMapper from 'src/helpers/urlParamsMapper.js';
import ContentParser from 'src/ui/library/ContentParser';
import { ActionsBarContainer } from 'src/ui/features/Questionnaire/containers';
import flattenSubMenu from 'src/helpers/flattenSubMenu.js';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import iconTransform from 'src/helpers/iconTransform';
// import UserGuide from "src/ui/features/UserGuide";
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';

//const goldColor = '#f5a623';
//const greenColor = '#2eb757';

const parsePercentString = value => parseInt(value, 10);
let saveQuestionnaireFn = () => {};
let forceDisableSubmitBtnFn = () => {};

export const QuestionnairePagePres = ({
  sectionProgress,
  introData,
  pageData,
  push,
  isMobile,
  goBack,
  match,
  setFormValues,
  formValues,
  setSaveHandler,
  onSave,
  savingPage,
  setShowErrors,
  isShowingErrors,
  isMenuClicked,
  resetMenuButtonClicked,
  history,
  showUserGuide,
  reloadPage,
  toggleReloadPage,
  displaySavePOPUP,
  elementUD
}) => {
  // if (!introData || !pageData || savingPage) {
  if (!pageData || savingPage) {
    return <ServiceSpinner />;
  }
  const overallProgress = parsePercentString(introData.overallProgress);
  let { sectionName, pageId } = match.params;
  sectionName = (pageData.sectionNameOldNew && JSON.parse(pageData.sectionNameOldNew)[sectionName]) || sectionName;
  match.params.sectionName = sectionName;
  // const { sectionProgress } = introData.menus.filter(m => m.menuName === sectionName)[0] || {};

  const { menuName, subMenu } = pageData.menus.filter(m => m.menuName === sectionName)[0] || {};
  let pageObj = {};
  if (subMenu && subMenu.length) {
    const flattenedSubMenu = flattenSubMenu(subMenu);
    pageObj = flattenedSubMenu.filter(m => m.pageId === Number(pageId))[0] || {};
  }
  const { align, icon } = pageObj;
  const sectionProgressPercent = sectionProgress && sectionProgress[sectionName] ? sectionProgress[sectionName].progress : 0;

  const redirectPage = () => {
    const headerDetailsObject = sessionStorage.getItem('headerDetails');
    const headerDetails = JSON.parse(headerDetailsObject);
    const caseManagerId = headerDetails.caseManagerId ? headerDetails.caseManagerId : sessionStorage.getItem('caseManagerId');
    push(`${CASE_DETAIL_URL}/${caseManagerId}`);
  };
  //// console.log(JSON.stringify(formValues))
  return (
    <div className="questionnaire-page-body">
      <QuestionnaireTopHeader
        title={pageObj.menuName}
        onClose={() => (elementUD ? displaySavePOPUP(true) : onSave(() => redirectPage()))}
        overallProgress={overallProgress}
        isDataPage
      />
      <div className="questionnaire-page-title-container">
        <Grid container className="header-title-container">
          <Grid item xs={12}>
            <div className="data-page-header">
              {icon && <span className="data-page-icon">{iconTransform(icon, !isMobile && { fontSize: 30 })}</span>}
              <span className="data-page-title">
                <h2 className="title-header">{pageObj.menuName}</h2>
              </span>
              <span className="data-page-save">
                <Link
                  component="button"
                  underline="hover"
                  className="textLink-button"
                  onClick={() => onSave(push(urlParamsMapper(QUESTIONNAIRE_PAGE_URL, match.params)))}>
                  <SaveIcon sx={{ mr: 0.5, verticalAlign: 'text-top', fontSize: 14 }} />
                  {intl.get('questionnaire.actionBar.save')}
                </Link>
              </span>
            </div>
          </Grid>
        </Grid>
      </div>

      <article className="questionnaire-page-container">
        {/* <header history={history} className="hide-mobile1">
          <div className="questionnaire-status">
            <span>
              <PercentageCircle
                color={overallProgress === 100 ? greenColor : goldColor}
                percent={overallProgress}
                radius={35}
                borderWidth={5}>
                <div className="circle-inner-text">
                  <div className={'percentage circle-font-size'}>{overallProgress}%</div>
                  <span className="text">{intl.get('questionnaire.overall')}</span>
                </div>
              </PercentageCircle>
            </span>
          </div>
        </header> */}

        {/* <div>
        {
            showUserGuide === true ?
            <UserGuide open={showUserGuide}/>: 
            null
        }    
        </div> */}

        {
          <div className="content-parser-container mobile-border-none">
            <ContentParser
              key={pageData.pageId}
              pageId={pageData.pageId}
              data={pageData}
              onChange={setFormValues}
              showLabels={false}
              numberOfColumns={isMobile ? 1 : pageData.numberOfColumns || 3}
              debug={false}
              hasError={isShowingErrors}
              actions={{
                saveQuestionnaire: (cb, isFormComplete) => saveQuestionnaireFn(reloadPage, false, cb, true, isFormComplete),
                forceDisableSubmitBtn: isDisabled => forceDisableSubmitBtnFn(isDisabled),
              }}
              reloadPage={reloadPage}
              toggleReloadPage={toggleReloadPage}
              parentReadOnly={false}
            />
          </div>
        }
      </article>

      <ActionsBarContainer
        progressTitle={menuName}
        isMenuClicked={isMenuClicked}
        formValues={formValues}
        percentProgress={sectionProgressPercent}
        isPageVariant={true}
        routeParams={match.params}
        setSaveHandler={setSaveHandler}
        setShowErrors={setShowErrors}
        getSaveFn={fn => (saveQuestionnaireFn = fn)}
        resetMenuButtonClicked={resetMenuButtonClicked}
        getforceDisableSubmitBtnFn={fn => (forceDisableSubmitBtnFn = fn)}
        reloadPage={reloadPage}
        toggleReloadPage={toggleReloadPage}
        onSubmitComplete={() => redirectPage()}
      />
    </div>
  );
};

export default QuestionnairePagePres;



// WEBPACK FOOTER //
// ./src/ui/features/Questionnaire/presentational/QuestionnairePagePres.js